
import { ProgressTracking } from "@/components/ProgressTracking";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

const Progress = () => {
  const navigate = useNavigate();

  return (
    <div className="relative min-h-screen bg-gray-50 p-8">
      <Button
        onClick={() => navigate("/")}
        variant="outline"
        className="mb-8"
      >
        Back to Home
      </Button>
      <ProgressTracking 
        familyName="Fox Family"
        googleDriveUrl="https://drive.google.com/drive/folders/1budGqWYnMk_Pq1-sddQczNra8xKiRwF-?usp=drive_link"
        password="fox"
      />
    </div>
  );
};

export default Progress;
